import React, { useState } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
} from "App/Component/ui";
import {
  dataDropdownJeniGudangUtama,
  RESET_STATE_MASTER_GUDANG_UTAMA,
  STYLE_MASTER_GUDANG_UTAMA,
  urlGudangUnit,
  urlAdd,
  urlUpdate,
} from ".";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";

import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  isNull,
} from "App/utils/helpers";
import { useSelectOption } from "App/hooks";

export default function FormMasterGudangUtama({
  formData,
  setFormData,
  setRows,
}) {
  const classes = STYLE_MASTER_GUDANG_UTAMA();

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const unit = useSelectOption(true, urlGudangUnit, TYPE_INSTANCE4);

  const add = async () => {
    return instance4.post(urlAdd, {
      ...formData,
    });
  };

  const update = () => {
    return instance4.put(`${urlUpdate}/${formData.id}`, {
      ...formData,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama atau Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah Gudang");
          setFormData(RESET_STATE_MASTER_GUDANG_UTAMA);
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah Gudang");
          setFormData(RESET_STATE_MASTER_GUDANG_UTAMA);
        }
        const newData = await fetchData(
          TYPE_INSTANCE4,
          "/wmsmaster/gudang/read"
        );
        setRows(newData);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_MASTER_GUDANG_UTAMA);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              value={formData.id}
              onChange={handleChange("id")}
              placeholder='ID'
              disabled={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='idjenis'
              label='JENIS'
              id='idjenis'
              withSearch={false}
              value={formData.idjenis}
              onChange={handleChange("idjenis")}
              data={dataDropdownJeniGudangUtama}
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name='name'
              label='NAMA'
              id='name'
              placeholder='Nama Gudang Utama'
              value={formData.name}
              onChange={handleChange("name")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='idunit'
              label='UNIT'
              id='idunit'
              withSearch={true}
              data={unit}
              labelValue={formData.unit_name}
              value={formData.idunit}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    idunit: null,
                    unit_name: "Pilih Unit",
                  });
                } else {
                  setFormData({
                    ...formData,
                    idunit: e.value,
                    unit_name: e.label,
                  });
                }
              }}
            />
          </Grid>
        </Grid>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              onClick={() => setFormData(RESET_STATE_MASTER_GUDANG_UTAMA)}
              color='danger'
              name='Reset'
              size='md'
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size='md'
            />
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
